import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Button } from 'primereact/button';
import Navbar from './navbar'
import logo from "../../assets/vmou.png";
import 'primeflex/primeflex.css';
import 'primeicons/primeicons.css'
import Batch from "../batch/batchtable"
import './main.css'
import * as actions from '../../store/actions/index'
import { Sidebar } from 'primereact/sidebar';
 const Main = (props) => {
    const [visibleRight, setVisibleRight] = useState(false);
    const onSignout = () => {
      props.onlogout();
    }
    return (
      <div className="Usr">
        <Sidebar className="flex align-items-center " visible={visibleRight} position="right" onHide={() => setVisibleRight(false)}>
          <h2>User Profile....</h2>
          <h5>Examiner ID : {props.email}</h5>
          <h5>Name        : {props.username}</h5>
          <Button className="p-button-text p-button-danger ml-4" style={{}} onClick={onSignout}>Sign Out</Button>
        </Sidebar>
        <div className="Headerusr" style={{position:'sticky'}} >
          <img src={logo} alt="VMOU" height={100} width={90} style={{margin:'0px 0 0 20px'}} ></img>
          <h2 style={{marginTop:'0', textAlign:'center'}}>Examiner Module<br/>Batch Management</h2>
          <div className="Userusr" onClick={(e) => setVisibleRight(true)}>
            <i style={{'fontSize': '1.5em'}} className="pi pi-user mr-6 mt-2 text-right"></i>
            <h4 style={{margin:'0 30px 0 0',textAlign:'end'}} >Hi, {props.username}</h4>
          </div>
        </div>
        <Navbar/>
        <Batch/>
      </div>
    );
}

const mapStateToProps = state => {
  return {
      username:state.auth.username,
      email:state.auth.email,
      userid:state.auth.userid,
      isAuth:state.auth.token!==null,
  }
}
const mapDispatchToProps = dispatch => {
  return {
      onlogout:() => dispatch(actions.logout())
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Main);